module.exports = __webpack_public_path__ + "img/Ausgefüllter_Raum.416dee49.svg";